export default "https://cdn.questicon.mathletics.com/assets/images/cross-8cf2697c6581d2904a7761ed8a7e52f5.svg";